// The files in the platform agent's message box (D6, docs/platform-agent/contracts.md §8). The label, placeholder
// and hint stay in PlatformAgentConversation's `composer`.
export default {
  drop: 'Pudota tiedostot tähän: PDF, valokuvat, Excel, CSV tai Word',
  waiting: 'Lähetys odottaa, kunnes tiedostot on ladattu.',
  // A PDF's pages on its tile (B37): "PDF · 1.2 MB · 4 pages".
  pages_one: '{{count}} sivu',
  pages_other: '{{count}} sivua',
  problems: {
    type: 'Tämän tyyppistä tiedostoa ei voi lähettää. Lähetä PDF, valokuva (JPG, PNG tai HEIC) tai Excel-, CSV- tai Word-tiedosto.',
    size: 'Yli 20 Mt. Tiedoston enimmäiskoko on 20 Mt.',
    empty: 'Tämä tiedosto on tyhjä.',
    count: 'Enintään 10 tiedostoa viestissä.',
    upload: 'Lataus keskeytyi. Yritä uudelleen.',
  },
};
